export const REASON_CODES = {
  BILLING_CYCLE_CHECK: 'ERR_POLICY_ORCH_001',
  TERMED_SUB_CHECK: 'ERR_POLICY_ORCH_002',
  NET14__MAX_LIMIT_CHECK: 'ERR_POLICY_ORCH_003',
  NET14__MIN_LIMIT_CHECK: 'ERR_POLICY_ORCH_004',
  NETX_INELIGIBLE_CHECK: 'ERR_POLICY_ORCH_008',
  ESTIMATE_UNAVAILABLE_CHECK: 'ERR_POLICY_ORCH_006',
};
